import { Button, Box, Stack, Typography } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import { formatPrice } from '@vy/services';
import { CURRENCIES } from '@vy/types';
import { isNotNullOrUndefined } from '@vy/utils';

type CustomerNavRevenueProps = {
  lifecycleRevenue: number;
  availableBalance?: number;
  entriesOverviewDisabled?: boolean;
  onCreditEntriesClick: () => void;
};

export const CustomerNavRevenue: React.FC<CustomerNavRevenueProps> = ({
  lifecycleRevenue,
  availableBalance,
  entriesOverviewDisabled,
  onCreditEntriesClick,
}) => {
  return (
    <Stack
      direction="row"
      sx={{
        alignItems: "center",
        justifyContent: "center",
        padding: "0 5px"
      }}>
      <Box sx={{ padding: '16px', paddingLeft: '30px' }}>
        <VyIcon icon="Coin" strokeOpacity={0} />
      </Box>
      <Stack direction="column">
        <Stack direction="column" sx={{
          alignItems: "flex-start"
        }}>
          <Typography
            sx={{
              fontSize: 12,
              color: "text.secondary"
            }}>
            Lifetime Income
          </Typography>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: 32,
              color: "text.primary"
            }}>
            {formatPrice(lifecycleRevenue, CURRENCIES.Usd, 0, 0)}
          </Typography>
        </Stack>

        {isNotNullOrUndefined(availableBalance) && (
          <Button
            variant="text"
            disabled={entriesOverviewDisabled}
            onClick={onCreditEntriesClick}
            sx={{
              color: 'text.secondary',
              fontSize: '12px',
              fontWeight: 400,
              padding: 0,
              minWidth: 0,
              '&.Mui-disabled': { color: 'text.secondary' },
            }}
          >
            <Stack direction="row" spacing={0.5} sx={{
              alignItems: "center"
            }}>
              <Typography
                sx={{
                  fontSize: 12,
                  color: "text.secondary"
                }}>
                Available Balance:
              </Typography>
              <Typography
                sx={{
                  fontSize: 12,
                  color: "text.primary",
                  fontWeight: 400
                }}>
                {formatPrice(availableBalance, CURRENCIES.Usd, 0, 0)}
              </Typography>
            </Stack>
          </Button>
        )}
      </Stack>
    </Stack>
  );
};
